import {useEffect, useLayoutEffect} from 'react';

/**
 * SSR 시에 useLayoutEffect 를 호출하면 리액트가 warning 을 줘서 SSR 시에는 useEffect 를 사용
 * 참고 링크: https://github.com/reduxjs/react-redux/blob/8605088606403f6909597405c67db91d907db86e/src/components/connectAdvanced.js#L35-L41
 */
const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
export default useIsomorphicLayoutEffect;
